export default __webpack_public_path__ + "static/media/patient_icon.4432d867.svg";